import styled from 'styled-components';
import { TextInputField } from 'evergreen-ui';

const StyledInputField = styled(TextInputField)`
  padding: 25px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
  border-radius: 5px;
  border: none;
  color: #a7aaac;
  border-radius: 8px;
  background-color: #2b2d2e;
`;

export default StyledInputField;
